import { useState, useEffect } from 'react';

function getDimension() {
	const { innerWidth: width, innerHeight: height } = window;
	return {
		width,
		height,
	};
}

const useWindowIsMobile = (mobileWidth = 1200) => {
	const [ windowDimensions, setWindowDimensions ] = useState(getDimension());
	useEffect(() => {
		function handleResize() {
			setWindowDimensions(getDimension());
		}

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	return windowDimensions.width <= mobileWidth;
};

export default useWindowIsMobile;